import SJButton from '@/components/SJButton'
import SJCard from '@/components/SJCard'
import SJCell from '@/components/SJCell'
import SJSpace from '@/components/SJSpace'
import { useNavigate } from 'react-router-dom'
import './index.less'

const list = [
  { title: '安卓手机获取不到Wi-Fi？' },
  { title: 'iOS手机获取不到Wi-Fi？' },
  { title: '获取到Wi-Fi列表但是没有想要连接的Wi-Fi？' },
  { title: '二维码无效？' },
  { title: '如何与机器人对话？' },
  { title: '利用手机热点，设备无法联网？' },
]
const Help = () => {
  document.title = '帮助与反馈'
  const navigate = useNavigate()
  const goFeedback = () => {
    navigate('/feedback')
  }

  const handleClick = (i: number) => {
    navigate('/question', { state: { id: String(i) } })
  }

  return (
    <div className="page help">
      <div className="main">
        <SJSpace height={20} />
        <div className="title">热点问题</div>
        <div className="content">
          <SJCard className="list">
            {list.map((item, index) => (
              <SJCell
                key={index}
                title={item.title}
                indicator
                onClick={() => handleClick(index + 1)}
              />
            ))}
          </SJCard>
        </div>
      </div>
      <div className="btn-fixed">
        <SJButton type="primary" size="large" onClick={goFeedback}>
          意见反馈
        </SJButton>
      </div>
    </div>
  )
}

export default Help
